import styled from "styled-components";

export const Container = styled.div`
  margin: 5px;
`;
export const Title = styled.span`
  font-size: 10px;
  font-weight: bold;
  margin-left: 5px;
  text-transform: uppercase;
`;
